import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CreateAdModal from '../components/CreateAdModal'; // The component we built
import './PostAdPage.css';

const PostAdPage = () => {
    const navigate = useNavigate();

    const handleAdPosted = () => {
        navigate('/profile'); // <-- 3. Use the navigate function to change pages
    };
    
    const handleGoBack = () => {
        navigate(-1); // A simple way to go back one page
    }

    return (
        <div className="post-ad-page">
            <div className="post-ad-container">
                <div className="post-ad-header">
                    <button onClick={handleGoBack} className="back-button">←</button>
                    <h1>ప్రకటనను పోస్ట్ చేయండి (Post Ad)</h1>
                </div>

                <div className="post-ad-info-card">
                    <h3>మీ వ్యాపారాన్ని వేలమందికి చేరవేయండి!</h3>
                    <p className="price-tag">ప్రకటన ధర: ₹100 నుండి ప్రారంభం</p>
                    <ul className="info-list">
                        <li>ఒక ప్రాంతానికి (Mandal/Constituency) ₹100 మాత్రమే.</li>
                        <li>మీ ప్రకటన 30 రోజుల పాటు లైవ్‌లో ఉంటుంది.</li>
                        <li>అన్ని పోస్టుల (Home Page) కోసం 'General' ఎంచుకోండి.</li>
                    </ul>
                </div>
                
                <div className="ad-form-wrapper">
                    {/* The logic for pricing and fields lives inside this component */}
                    <CreateAdModal onClose={handleAdPosted} />
                </div>
            </div>
        </div>
    );
};

export default PostAdPage;